Vue.component('leaderboard', {
  template: templates.leaderboard,
  data() {
    return {
      model: {
        users: [],
        top: [],
        medals: []
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.getMedals();

    $('[data-view="viewer-dashboard"]').on('click', '[data-component="leaderboard"] .medal', function(e) {
      c.show($(this).clone());
    });

    $('[data-view="viewer-dashboard"]').on('click', '.view-element', function() {
      c.hide();
    });
  },
  methods: {
    get() {
      const c = this;

      userService.getLeaderboard()
        .then(function (response) {

          for (let data of response.data) {

            let achievements = [];

            for (let i = 0; i < data.achievements.length; i++) {
              achievements.push({
                id: data.achievements[i],
                image: `/images/medals/${data.achievements[i]}.png`,
              });
            }

            data.achievements = achievements;
          }

          c.model.users = response.data;

          let first = response.data.slice(0, 1);
          let second = response.data.slice(1, 2);
          let third = response.data.slice(2, 3);
          c.model.top = [second[0], first[0], third[0]];
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getMedals() {
      const c = this;

      medalService.get()
        .then(function (response) {
          //medals = response.data;
          for (let medal of response.data) {
            medal.image = `/images/medals/${medal.id}.png`;
          }
          c.model.medals = response.data;
        })
        .catch(function (error) {
          
        });
    },
    show($element) {
      const c = this;
      let id = $element.data('id');
      let video = `/videos/medals/${id}.webm`;
      let name = '';
      let description = '';

      for (let medal of c.model.medals) {
        if (medal.id == id) {
          name = medal.name;
          description = medal.description;
          break;
        }
      }

      //let description = $card.find('.bottom > div:first-of-type').data('description');
      $element.find('.description').attr('class', '');

      let html = `<div class="medal">`;
      html += `<div class="video"></div>`;
      html += `<p title="${name}">${name}</p>`; 
      html += `<p title="${description}" class="">${description}</p>`;
      html += `</div>`;

      let $popup = $(html);
      $popup.find('.video').append($element);

      var testEl = document.createElement( "video" ), webm;
      if ( testEl.canPlayType ) {
          // Check for Webm support
          webm = "" !== testEl.canPlayType( 'video/webm; codecs="vp8, vorbis"' );
          if (webm) {
            $popup.find('img').replaceWith(`<video src="${video}" class="video-overlay__video" loop muted autoplay playsinline></video>`);
          }
      }

      $('.view-element > div').append($popup);
      $('.view-element').addClass('is-above').addClass('is-visible');
    },
    hide() {
      $('.view-element').removeClass('is-visible');
      setTimeout(function() {
        $('.view-element').removeClass('is-above');
        $('.view-element > div').html('');
      }, 300);
    }
  }
});